import { render, staticRenderFns } from "./myUnion.vue?vue&type=template&id=b9fcca8e&scoped=true"
import script from "./myUnion.vue?vue&type=script&lang=js"
export * from "./myUnion.vue?vue&type=script&lang=js"
import style0 from "./myUnion.vue?vue&type=style&index=0&id=b9fcca8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fcca8e",
  null
  
)

export default component.exports